import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, TemplateRef, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { MsalService } from '@azure/msal-angular';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SearchUsersComponent } from '../search-users/search-users.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() valueChange = new EventEmitter<{ action: any[] }>;
  @Input() activityData: boolean;

  auditTrail: any = {};

  isProcessing = false;
  actionsDataForGrid: any = [];
  action: any = {};
  bussinessAreaName: any;
  dropDownForRequestedAt: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isAdenabled: boolean = false;
  requestedAtTxt: any;
  coreBusinessAreaNameTxt: any;
  assignedUserTxt: any;
  departmentCodeTxt: any;
  reviewUserTxt: any;
  reviewUserTxt1: any;
  approveUserUserTxt: any;
  approveUserUserTxt1: any;
  deferReviewUserTxt: any;
  deferReviewUserTxt1: any;
  deferApproveUserTxt: any;
  deferApproveUserTxt1: any;
  designationCodeTxt: any;

  isrequestedAtOdd: any = null;
  iscoreBusinessAreaNameOdd: any = null;
  isassignedUserOdd: any = null;
  isdepartmentCodeOdd: any = null;
  isreviewUserOdd: any = null;
  isapproveUserUserOdd: any = null;

  oddDeferReviewer: any = null;
  oddDeferApprover: any = null;

  reviewStatus: any = [];
  getQmsBusinessAreaDetail: any;
  filteredRequestedAtValue: any;
  filteredBusinessAreaValue: any;
  coreBusinessAreaNameDropdown: any = [];
  coreBusinessAreaNameValue: any = [];
  selectCoreBusinessAreaNameValueExp: any = [];
  moduleNameForDropdown: any = [];
  dropDownDataForDocumentType: any = [];
  listOfReviewerUsers: any = [];
  listOfApproverUsers: any = [];
  listOfDeferredReviewerUsers: any = [];
  listOfDeferredApproverUsers: any = [];
  listOfUsers: any = [];
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  event = { isUserInput: true, source: { _selected: true, } }

  actionTypeList: any = [];
  dropDownForActionType: any = [];
  selectedActionType: any = [];

  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly qmsservice: qmsService,
    readonly appService: AppService,
    readonly message: messageService,
    readonly paginationService: PaginationService,

    private readonly renderer: Renderer2,
    private readonly snackBar: MatSnackBar,
    private readonly authService: MsalService,
    private readonly elem: ElementRef
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.appService.getCodeListsByGroup("ACTION_TYPE").subscribe((data: any) => {
      this.actionTypeList = data;
      this.selectBoxForActionType();
    });
  };

  selectBoxForActionType() {
    this.dropDownForActionType = this.actionTypeList?.map((type: any) => ({
      valueExp: type?.codelistCode,
      displayExp: type?.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onActionTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('action-type', this.selectedActionType);
        this.isAllActionTypeSelected = this.dropDownForActionType.length == this.selectedActionType.length;
      })
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = 'action-type';
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value); requiredElement?.focus();
    }, 0)
  };

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';

    if (this.qmsservice.selectedGroup != null) {
      this.filteredRequestedAtValue = [];
      this.isProcessing = true;
      this.dropDownForRequestedAt = JSON.parse(sessionStorage.getItem('dropDownForRequestedAt') ?? '{}');
      this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
      this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
      this.moduleNameForDropdown = localStorage.getItem("moduleNameFromCr");
      this.appService.getCodeListsByGroup("DOCUMENT_TYPE").subscribe((data: any) => {
        this.dropDownDataForDocumentType = data;
        this.callSelectBoxValues();
        this.isProcessing = false;
      });
      this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Action Reviewer').subscribe((data: any) => {
        this.listOfReviewerUsers = data;
        this.callReviewerUserListSelectBoxValues();
      });
      this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Action Approver').subscribe((data: any) => {
        this.listOfApproverUsers = data;
        this.callApproverUserListSelectBoxValues();
      });
      this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Action Deferred Reviewer').subscribe((data: any) => {
        this.listOfDeferredReviewerUsers = data;
        this.callDeferredReviewerUserSelectBoxValues();
      });
      this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Action Deferred Approver').subscribe((data: any) => {
        this.listOfDeferredApproverUsers = data;
        this.callDeferredApproverUserSelectBoxValues();
      });

      this.appService.getOneQmsUsersWithRolesVwDetails("QMS").subscribe((response: any) => {
        for (const element of response) {
          element.isActive = element.isActive == "Y";
        }
        this.listOfUsers = response;
        this.listOfUsers = this.listOfUsers.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
        this.selectBoxeForUserList();
        this.isProcessing = false;
      });
      this.appService.getQmsBusinessAreasByModule(this.qmsservice.moduleName).subscribe((data: any) => {
        this.getQmsBusinessAreaDetail = data;
        this.filteredRequestedAtValue = this.getQmsBusinessAreaDetail;
        this.selectBoxeForRequestedAt();

      });
      if (this.message.showSwitchUser) {
        this.message.showSwitchUser = true;
      } else {
        this.message.showSwitchUser = false;
      }

      if (this.qmsservice.activityId != null && this.qmsservice.activityId != "") {
        if (this.activityData) {
          this.getCall();
        } else {
          this.openEditPopup(this.message.taskLevelData, 0);
        }
      }
      this.getDynamicLabel();
    }
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  private getDynamicLabel(): void {
    this.isProcessing = true;
    let data = {
      tableName: 'QMS_ACTIONS_VW',
      moduleName: this.qmsservice.moduleName,
      gridName: 'ACTIONS',
      groupId: this.qmsservice.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  label: any = [];
  dynamicLabel: any = null;

  callDeferredReviewerUserSelectBoxValues() {
    this.listOfDeferredReviewerUsersDropdown = this.listOfDeferredReviewerUsers?.map((dr: any) => ({
      valueExp: dr?.userId,
      displayExp: dr?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  callDeferredApproverUserSelectBoxValues() {
    this.listOfDeferredApproverUsersDropdown = this.listOfDeferredApproverUsers?.map((da: any) => ({
      valueExp: da?.userId,
      displayExp: da?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  callReviewerUserListSelectBoxValues() {
    this.listOfReviewerUsersDropdown = this.listOfReviewerUsers?.map((reviewer: any) => ({
      valueExp: reviewer?.userId,
      displayExp: reviewer?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onReviewUserSelect(item: any) {
    if (this.reviewUserFieldValue != undefined) {
      this.reviewUserFieldValue.style.color = '#005c8a';
    }
  }

  callApproverUserListSelectBoxValues() {
    this.listOfApproverUsersDropdown = this.listOfApproverUsers?.map((approver: any) => ({
      valueExp: approver?.userId,
      displayExp: approver?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onApproverUserSelect(item: any) {
    if (this.approverUserFieldValue != undefined) {
      this.approverUserFieldValue.style.color = '#005c8a';
    }
  }

  selectBoxeForUserList() {
    this.listOfUsersDropdown = this.listOfUsers?.map((user: any) => ({
      valueExp: user?.userId,
      displayExp: user?.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  selectBoxeForDepartmentCode() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((dept: any) => ({
      valueExp: dept?.codelistCode,
      displayExp: dept?.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  selectBoxeForRequestedAt() {
    this.RequestedAtDropdown = this.filteredRequestedAtValue?.map((x: any) => ({
      valueExp: x?.taskRequestedAt,
      displayExp: x?.taskRequestedAt,
      listOfBusinessArea: x.listOfBusinessArea
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }


  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        if (this.searchingByRequestedAt != item.valueExp) {
          this.coreBusinessAreaNameValue = [];
          this.coreBusinessAreaNameDropdown = [];
          this.bussinessAreaName = '';
        }
        this.coreBusinessAreaNameDropdown = [];
        if (item.displayExp == undefined) {
          this.bussinessAreaName = item;
          let businessAreaValue = this.RequestedAtDropdown.find((x: any) => x.valueExp === item);
          this.filteredBusinessAreaValue = businessAreaValue.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        } else {
          this.bussinessAreaName = item.displayExp;
          let businessAreaValue = this.RequestedAtDropdown.find((x: any) => x.valueExp === item.displayExp);
          this.filteredBusinessAreaValue = businessAreaValue.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        if (this.activityAtFieldValue != undefined) {
          this.activityAtFieldValue.style.color = '#005c8a';
        }
      } else {
        this.coreBusinessAreaNameValue = [];
        this.coreBusinessAreaNameDropdown = [];
        this.bussinessAreaName = '';
      }
    }
  }

  @ViewChild('coreBusinessAreaName') coreBusinessAreaName: MatSelect;
  coreBusinessAreaNameSelected = false;
  @ViewChild('actionType') actionType: MatSelect;
  isAllActionTypeSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'coreBusinessAreaName') {
      if (this.coreBusinessAreaNameSelected) {
        this.coreBusinessAreaName.options.forEach((item: MatOption) => item.select());
      } else {
        this.coreBusinessAreaName.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'actionType') {
      if (this.isAllActionTypeSelected) this.actionType.options.forEach((item: MatOption) => item.select());
      else {
        this.actionType.options.forEach((item: MatOption) => item.deselect())
        this.selectedActionType = [];
      }
      setTimeout(() => { this.handleDropDownValidation('action-type', this.selectedActionType) });

    }
  }

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectCoreBusinessAreaNameValueExp = item.valueExp;
        if (this.coreBusinessAreaNameValueFieldValue != undefined) {
          this.coreBusinessAreaNameValueFieldValue.style.color = '#005c8a';
        }
      } else if (this.coreBusinessAreaNameValueFieldValue != undefined) {
        this.coreBusinessAreaNameValueFieldValue.style.color = 'red';
      }

      setTimeout(() => {
        this.coreBusinessAreaNameSelected = this.coreBusinessAreaNameDropdown.length == this.coreBusinessAreaNameValue.length;
      })
    }
  }

  selectedModule: any = [];
  selectedModuleDisplayExp: any = [];
  selectedModuleValueExp: any = [];
  moduleListDropdown: any = [];

  selectedDocumentType: any = [];
  selectedDocumentTypeDisplayExp: any = [];
  selectedDocumentTypeValueExp: any = [];
  documentTypeListDropdown: any = [];
  searchingByRequestedAt: any = null;
  dropDownForReasonForChange: any = [];
  RequestedAtDropdown: any = [];
  listOfUsersDropdown: any;
  listOfReviewerUsersDropdown: any;
  listOfApproverUsersDropdown: any;
  listOfDeferredReviewerUsersDropdown: any;
  listOfDeferredApproverUsersDropdown: any;
  searchingByReviewUser: any = null;
  searchingByAssignedUser: any = null;
  searchingByApproveUser: any = null;
  searchingByDeferReviewUser: any = null;
  searchingByDeferApproveUser: any = null;
  searchTypeText: string = '';
  callSelectBoxValues() {
    this.moduleListDropdown = this.moduleListDropdown.concat({
      valueExp: this.moduleNameForDropdown,
      displayExp: this.moduleNameForDropdown
    });

    this.documentTypeListDropdown = this.dropDownDataForDocumentType?.map((docType: any) => ({
      valueExp: docType.codelistCode,
      displayExp: docType.codelistName
    }))
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    this.selectBoxeForRequestedAt();
  }

  isActiveToggerBoxValue: boolean;
  isActiverFunction(isTagged: boolean) {
    this.isActiveToggerBoxValue = isTagged;

  }

  refreshGridData() {
    this.isProcessing = true;
    this.getCall();
  }

  visibleEditButton: boolean;
  popupDataTitle: any;
  @ViewChild('confirmationPopup', { static: true }) confirmationPopup: TemplateRef<any>;
  confirmationMessage: string = '';
  confirmationPopupRef: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '1px', left: '7%' },
    maxWidth: '91vw',
  };

  conformPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog-center-top',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '50px' }, // vertical distance from top
    maxWidth: '91vw',
  };


  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmYes() {
    this.confirmationPopupRef.close();
    this.proceedToOpenAddPopup(); // Continue as normal
  }

  closeConfirmPopup() {
    this.confirmationPopupRef.close();
  }
  proceedToOpenAddPopup() {
    this.isrequestedAtOdd = null;
    this.iscoreBusinessAreaNameOdd = null;
    this.isassignedUserOdd = null;
    this.isdepartmentCodeOdd = null;
    this.isreviewUserOdd = null;
    this.isapproveUserUserOdd = null;
    this.buttonList = ["Save", "Cancel"];
    this.searchingByRequestedAt = null;
    this.coreBusinessAreaNameValue = [];
    this.selectedActionType = [];
    this.coreBusinessAreaNameDropdown = [];
    this.searchingByAssignedUser = null;
    this.searchByDepartmentCode = null;
    this.searchingByReviewUser = null;
    this.searchingByApproveUser = null;
    this.action = {};
    this.visibleEditButton = false;
    this.popupDataTitle = "Create Action";
    this.selectedModule = [];
    this.selectedDocumentType = null;
    this.bussinessAreaName = '';
    this.qmsservice.getQmsActionDataUsingById = {};
    this.coreBusinessAreaNameSelected = false;
    this.action.actionDescription = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  openAddPopup() {

    const dv = this.qmsservice.activity;
    const validStatus = ["Draft", "Department Head Approved", "Pending Department Head Approval", "Department Head Rejected",
      "Department Head Requested More Info.", "QA Acceptance Rejected", "QA Requested More Info.", "Pending QA Acceptance",
      "QA Accepted", "Owner Requested More Info.", "Owner Acknowledged"].includes(dv.status);

    if (this.qmsservice.moduleName === 'DV' && validStatus && !dv?.investigationReqd) {
      this.confirmationMessage = `Please verify if the action item can be added prior to completing the investigation.`
      this.confirmationPopupRef = this.dialog.open(this.confirmationPopup, this.conformPopupConfig);

    } else if (this.qmsservice.moduleName === 'DV' && validStatus && dv?.investigationReqd && (!dv.investigationPlan || this.isContentEmpty(dv.investigationPlan))) {
      this.confirmationMessage = `Please make sure if the investigation is completed before adding action items!`
      this.confirmationPopupRef = this.dialog.open(this.confirmationPopup, this.conformPopupConfig);

    } else {
      this.isrequestedAtOdd = null;
      this.iscoreBusinessAreaNameOdd = null;
      this.isassignedUserOdd = null;
      this.isdepartmentCodeOdd = null;
      this.isreviewUserOdd = null;
      this.isapproveUserUserOdd = null;
      this.buttonList = ["Save", "Cancel"];
      this.searchingByRequestedAt = null;
      this.coreBusinessAreaNameValue = [];
      this.selectedActionType = [];
      this.coreBusinessAreaNameDropdown = [];
      this.searchingByAssignedUser = null;
      this.searchByDepartmentCode = null;
      this.searchingByReviewUser = null;
      this.searchingByApproveUser = null;
      this.action = {};
      this.visibleEditButton = false;
      this.popupDataTitle = "Create Action";
      this.selectedModule = [];
      this.selectedDocumentType = null;
      this.bussinessAreaName = '';
      this.qmsservice.getQmsActionDataUsingById = {};
      this.coreBusinessAreaNameSelected = false;
      this.isAllActionTypeSelected = false;
      this.action.actionDescription = '';
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    }
  }


  cancelAddAndEditFunction() {
    this.qmsservice.getQmsActionDataUsingById.status = undefined;
    this.visibleAddAndEditPopup.close();
  }

  getSelectedUserId: any;
  getSelectedUserName: string;

  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }
  btnClicked: string;
  searchManagerChildCheckBoxs: boolean = false;
  designationCodeValue: any = [];
  departmentCodeValue: any = [];
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  selectedDepartmentValue: any;
  selectedDesignationValue: any;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];

  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  searchByReviewByUser: any;
  ReviewByUserDropdown: any = [];
  visibleactionperfrom: boolean;

  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;


  selectBoxeForDesignationCode() {
    for (const element of this.dropDownForDesignationCode) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  onAssignedToSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.assignedToFieldValue != undefined) {
          this.assignedToFieldValue.style.color = '#005c8a';
        }
      }
    }
  }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDepartmentValue = item.valueExp;
      }
    }
  }

  onDepartmentCodeRemoved(item: any) { };

  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDesignationValue = item.valueExp;
      }
    }
  }

  onReviewByUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.reviewUserFieldValue != undefined) {
          this.reviewUserFieldValue.style.color = '#005c8a';
        }
      } else if (this.reviewUserFieldValue != undefined) {
        this.reviewUserFieldValue.style.color = 'red';
      }

    }
  }

  onReviewByUserRemoved(item: any) {
    if (this.reviewUserFieldValue != undefined) {
      this.reviewUserFieldValue.style.color = 'red';
    }
  }

  onApproveByUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.approverUserFieldValue != undefined) {
          this.approverUserFieldValue.style.color = '#005c8a';
        }
      } else if (this.approverUserFieldValue != undefined) {
        this.approverUserFieldValue.style.color = 'red';

      }
    }
  }

  onApproveByUserRemoved(item: any) {
    if (this.approverUserFieldValue != undefined) {
      this.approverUserFieldValue.style.color = 'red';
    }
  }

  onDesignationCodeRemoved(item: any) { };
  buttonList: any;
  buttongetCall() {
    this.buttonList = [];
    const obj = { actionId: this.action.actionId }
    this.appService.getActionButtons(obj).subscribe((data: any) => {
      if (data.labelsResult) {
        data.labelsResult = data.labelsResult + ",Cancel";
        this.buttonList = data.labelsResult.split(",");
      } else {
        data.labelsResult = "Cancel";
        this.buttonList = data.labelsResult.split(",");
      }
    });
  }

  idCall(actionId: any) {
    this.selectBoxeForRequestedAt();
    this.appService.getQmsActionsByActionId(actionId).subscribe((data: any) => {
      this.qmsservice.getQmsActionDataUsingById = data;
      data.actionPerformed = data.actionPerformed == "Y";
      this.action = data;


      this.popupDataTitle = "Edit Action";
      let businessAreaValues = this.RequestedAtDropdown.filter((x: any) => x.valueExp === data.actionAt);
      if (businessAreaValues.length > 0) {
        this.isrequestedAtOdd = null;
        this.filteredBusinessAreaValue = businessAreaValues[0].listOfBusinessArea?.split(',');
        this.searchingByRequestedAt = businessAreaValues[0].valueExp;
        let actionat = {
          displayExp: businessAreaValues[0].valueExp
        }
        this.onRequestedAtSelect(this.event, actionat);
      } else {
        this.isrequestedAtOdd = data.actionAt;
        this.RequestedAtDropdown.push({
          valueExp: data.actionAt,
          displayExp: data.actionAt
        })
        this.filteredBusinessAreaValue = [];
      }

      this.coreBusinessAreaNameValue = [];
      if (data.coreBusinessArea != null) {
        this.selectBoxForCoreBusinessAreaName();
        let str = data.coreBusinessArea.split(",");

        if (this.coreBusinessAreaNameDropdown.length > 0) {
          this.coreBusinessAreaNameValue = str;
        } else {
          this.coreBusinessAreaNameValue = data.coreBusinessArea;
        }
      };

      if (data.actionType) {
        this.selectedActionType = data.actionType?.split(",");
      } else {
        this.selectedActionType = [];
      }
      setTimeout(() => this.isAllActionTypeSelected = this.selectedActionType.length == this.dropDownForActionType.length);

      let departmentCodeValues = this.departmentCodeDropdown.filter((x: any) => x.valueExp === data.assignedToDepartment);
      if (departmentCodeValues.length > 0) {
        this.isdepartmentCodeOdd = null;

        this.searchByDepartmentCode = departmentCodeValues[0].valueExp;
      } else {
        this.searchByDepartmentCode = this.isdepartmentCodeOdd = data.assignedToDepartment;
        this.departmentCodeDropdown.push({
          valueExp: data.assignedToDepartment,
          displayExp: data.assignedToDepartment
        })
      }

      this.message.showDocumentActionButtons = (data.assignedToUser == this.message.getUserId() && (data.status == 'Open' || data.status == 'Review Rejected' || data.status == 'Approval Rejected' || data.status == 'Deferred(Review Rejected)' || data.status == 'Deferred(Approval Rejected)'));
      let reviewedByUser = this.listOfReviewerUsersDropdown.filter((x: any) => x.valueExp === data.reviewedByUser);
      if (reviewedByUser.length > 0) {

        this.searchingByReviewUser = reviewedByUser[0].valueExp;
        this.isreviewUserOdd = null;
      } else {
        this.searchingByReviewUser = this.isreviewUserOdd = data.reviewedByUser;
        this.listOfReviewerUsersDropdown.push({
          valueExp: data.reviewedByUser,
          displayExp: data.reviewer
        })
      }

      let approvedByUser = this.listOfApproverUsersDropdown.filter((x: any) => x.valueExp === data.approvedByUser);
      if (approvedByUser.length > 0) {

        this.searchingByApproveUser = approvedByUser[0].valueExp;
        this.isapproveUserUserOdd = null;
      } else {
        this.searchingByApproveUser = this.isapproveUserUserOdd = data.approvedByUser;
        this.listOfApproverUsersDropdown.push({
          valueExp: data.approvedByUser,
          displayExp: data.approver
        })
      }

      if (data.createdOn) {
        this.action.createdOn = new Date(data.createdOn)
      } else {
        this.action.createdOn = null
      }
      if (data.actionCompletedOn) {
        this.action.actionCompletedOn = new Date(data.actionCompletedOn)
      } else {
        this.action.actionCompletedOn = null
      }
      if (data.targetDate) {
        this.action.targetDate = new Date(data.targetDate);
      } else {
        this.action.targetDate = null;
      }
      if (data.actualActionCompletedOn) {
        this.action.actualActionCompletedOn = new Date(data.actualActionCompletedOn);
      } else {
        this.action.actualActionCompletedOn = null;
      }
      this.isProcessing = false;
    });
  }

  config: EditorConfig = {
    buttons: [],
  };


  fromdynamicBtn: boolean;
  deleteData: any;
  objForDocuments: any;
  openEditPopup(data: any, id: any) {
    this.selectBoxeForRequestedAt();
    this.fromdynamicBtn = false;
    this.coreBusinessAreaNameSelected = false;
    this.deleteData = data;
    this.message.subModuleId = data.ACTION_ID;
    this.oddDeferApprover = this.oddDeferReviewer = null;
    if (id == 0 || id == 1) {
      this.buttonList = [];
      this.isProcessing = true;
      this.action = {};
      this.searchingByDeferReviewUser = null;
      this.searchingByDeferApproveUser = null;
      this.searchingByAssignedUser = null;

      const obj = { actionId: data.ACTION_ID }
      this.appService.getActionButtons(obj).subscribe((data1: any) => {
        if (data1.labelsResult) {
          data1.labelsResult = data1.labelsResult + ",Cancel";
          this.buttonList = data1.labelsResult.split(",");
        } else {
          data1.labelsResult = "Cancel";
          this.buttonList = data1.labelsResult.split(",");
        }
        this.appService.getQmsActionsByActionId(data.ACTION_ID).subscribe((data: any) => {
          this.qmsservice.getQmsActionDataUsingById = data;
          data.actionPerformed = data.actionPerformed == "Y";
          this.action = data;
          this.objForDocuments = {
            id: this.action.actionId,
            pagename: "Action"
          };

          if (this.action.targetDate) {
            this.action.targetDate = new Date(this.action.targetDate);
          } else {
            this.action.targetDate = null;
          }
          if (this.action.actualActionCompletedOn) {
            this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
          } else {
            this.action.actualActionCompletedOn = null;
          }
          if (this.action?.createdOn) {
            this.action.createdOn = new Date(this.action.createdOn);
          }
          if (this.action?.actionCompletedOn) {
            this.action.actionCompletedOn = new Date(this.action.actionCompletedOn);
          }

          this.popupDataTitle = "Update Action";

          if (data.actionAt != '' && data.actionAt != undefined && data.actionAt != null) {
            let businessAreaValues = this.RequestedAtDropdown.filter((x: any) => x.valueExp === data.actionAt);
            if (businessAreaValues.length > 0) {
              this.filteredBusinessAreaValue = businessAreaValues[0]?.listOfBusinessArea?.split(',');
              this.searchingByRequestedAt = businessAreaValues[0].valueExp;
              this.isrequestedAtOdd = null;
              this.onRequestedAtSelect(this.event, businessAreaValues[0].valueExp);
            } else {
              this.searchingByRequestedAt = this.isrequestedAtOdd = data.actionAt;
              this.RequestedAtDropdown.push({
                valueExp: data.actionAt,
                displayExp: data.actionAt
              });
            }
          }

          this.coreBusinessAreaNameValue = [];
          if (data.coreBusinessArea) {

            if (this.coreBusinessAreaNameDropdown.length > 0) {
              let str = data.coreBusinessArea?.split(",");
              this.coreBusinessAreaNameValue = str;
            } else {
              this.coreBusinessAreaNameValue = data.coreBusinessArea;
            }
          };

          if (data.actionType) {
            this.selectedActionType = data.actionType?.split(",");
          } else {
            this.selectedActionType = [];
          }
          setTimeout(() => this.isAllActionTypeSelected = this.selectedActionType.length == this.dropDownForActionType.length);

          if (this.qmsservice.activity.status == 'In Progress' && this.action.assignedToUser == this.message.getUserId()) {
            this.visibleactionperfrom = true;
          } else {
            this.visibleactionperfrom = false;
          }


          if (data.assignedToDepartment != '' && data.assignedToDepartment != undefined && data.assignedToDepartment != null) {
            let departmentCodeValues = this.departmentCodeDropdown.filter((x: any) => x.valueExp === data.assignedToDepartment);
            if (departmentCodeValues.length > 0) {
              this.searchByDepartmentCode = departmentCodeValues[0].valueExp;
              this.isdepartmentCodeOdd = null;
            } else {
              this.searchByDepartmentCode = this.isdepartmentCodeOdd = data.assignedToDepartment;
              this.departmentCodeDropdown.push({
                valueExp: data.assignedToDepartment,
                displayExp: data.assignedToDepartment
              });
            }
          }

          let reviewedByUser = this.listOfReviewerUsersDropdown.filter((x: any) => x.valueExp === data.reviewedByUser);
          if (reviewedByUser.length > 0) {
            this.searchingByReviewUser = reviewedByUser[0].valueExp;
            this.isreviewUserOdd = null;
          } else {
            this.searchingByReviewUser = this.isreviewUserOdd = data.reviewedByUser;
            this.listOfReviewerUsersDropdown.push({
              valueExp: data.reviewedByUser,
              displayExp: data.reviewer
            });
          }

          let approvedByUser = this.listOfApproverUsersDropdown.filter((x: any) => x.valueExp === data.approvedByUser);
          if (approvedByUser.length > 0) {
            this.searchingByApproveUser = approvedByUser[0].valueExp;
            this.isapproveUserUserOdd = null;
          } else {
            this.searchingByApproveUser = this.isapproveUserUserOdd = data.approvedByUser;
            this.listOfApproverUsersDropdown.push({
              valueExp: data.approvedByUser,
              displayExp: data.approver
            });
          }

          this.deferApproveUser = null;
          this.deferReviewUser = null;

          if (data.deferReviewedByUser) {
            const matchingDeferReviewer = this.listOfDeferredReviewerUsers.find((deferReviewer: any) => deferReviewer.userId == data.deferReviewedByUser)
            if (!matchingDeferReviewer) {
              this.oddDeferReviewer = data.deferReviewedByUser;
              this.listOfDeferredReviewerUsersDropdown.push({
                valueExp: data.deferReviewedByUser,
                displayExp: data.deferReviewer
              })
            }
            this.deferReviewUser = this.searchingByDeferReviewUser = data.deferReviewedByUser;
          }

          if (data.deferApprovedByUser) {
            const matchingDeferApprover = this.listOfDeferredApproverUsers.find((deferApprover: any) => deferApprover.userId == data.deferApprovedByUser)
            if (!matchingDeferApprover) {
              this.oddDeferApprover = data.deferApprovedByUser;
              this.listOfDeferredApproverUsersDropdown.push({
                valueExp: data.deferApprovedByUser,
                displayExp: data.deferApprover
              })
            }
            this.deferApproveUser = this.searchingByDeferApproveUser = data.deferApprovedByUser;
          }

          this.visibleEditButton = true;
          this.message.showDocumentActionButtons = (data.assignedToUser == this.message.getUserId() && (data.status == 'Open' || data.status == 'Review Rejected' || data.status == 'Approval Rejected' || data.status == 'Deferred(Review Rejected)' || data.status == 'Deferred(Approval Rejected)'));
          this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
          this.isProcessing = false;
        });

      });

    }
  };

  public getSwitchUser(switching_for: string): boolean {
    if (switching_for == 'assign-to') {
      return this.action.status == 'Open' || this.action.status == 'Review Rejected' || this.action.status == 'Approval Rejected' || this.action.status == 'Deferred(Review Rejected)' || this.action.status == 'Deferred(Approval Rejected)';
    } else {
      return false;
    }
  }

  deferApproveUser: any = null;
  deferReviewUser: any = null;
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  isEsignRequired: boolean;
  isReasonSignReqd: boolean;
  buttonLabel: any;
  reason: any;
  userName: any;
  password: any = "";
  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  selectedStatus: any = null;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleValidationConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmValidationPopup', { static: true }) confirmValidationPopup: TemplateRef<any>;
  confirmValidationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmValidationOkFunc() {
    this.visibleValidationConfirm.close();
  };

  cancelValidationConfirmFunc() {
    this.visibleValidationConfirm.close();
  };
  async dynamicButtonClick(button: any) {

    if (this.qmsservice.activity.status == "In Progress" && await this.qmsservice.validateExtension({ refNo: this.qmsservice.activityId, extensionFor: "Action", subTaskNo: this.action.actionId })) {

      setTimeout(() => {
        this.showSnackBar(this.qmsservice.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.buttonLabel = button;
    this.selectedStatus = null;
    this.reason = "";
    this.password = "";
    this.userName = localStorage.getItem("loggedUserName");
    this.isEsignRequired = false;
    this.isReasonSignReqd = true;
    this.isEsignRequired = true;
    this.changetypeAddAndEditPassword = true;
    if (button == "Delete") {
      this.openDeletePopup(this.deleteData);
    } else {
      if (button == "Review") {
        this.reviewStatus = ['Reviewed', 'Review Rejected'];
      } else if (button == "Approve") {
        this.reviewStatus = ['Approved', 'Approval Rejected'];
      }

      let array: [] = [];

      this.isProcessing = true;
      this.appService.getDocumentsForActions(this.qmsservice.activityId, this.message.subModuleId).subscribe((response: any) => {
        array = response;
        this.isProcessing = false;
        if ((button == 'Submit for Review' || button == 'Submit for Approval' || button == 'Complete Action') && !this.action.actionPerformed) {
          this.showmessage("Action to be performed before submitting the next step", "E");
          this.dynamicButtonFieldValidation();
        } else if ((button == 'Submit for Review' || button == 'Submit for Approval' || button == 'Complete Action') && this.action.actionPerformed && !this.action.performedActionDetails) {
          this.showmessage("Please enter Performed Action Details", "E");
          this.dynamicButtonFieldValidation();
        }
        else if ((button == 'Submit for Review' || button == 'Submit for Approval' || button == 'Complete Action') && this.action.actionPerformed && !array.length) {
          this.showmessage("Please add supporting documents for Actions", "E");
        }


        else if (this.action.actionPerformed && button == 'Defer Action') {
          this.showmessage('Action Performed toggle button should be disabled in order to Defer', "E");
        } else {
          this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
        }
      })
    }
  }


  showmessage(result: any, resultType: any) {
    let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      //duration: 5000,
      data: {
        message: result,
        type: resultType == 'S' ? 'Success' : 'Error',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: resultType == 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  passwordFieldValue: any;
  reviewUserFieldValue: any;
  approverUserFieldValue: any;
  reviewAndapproveToggleValue: any;
  reasonFieldValue: any;
  dynamicButtonFieldValidation() {
    this.passwordFieldValue = document.getElementById('password-validation') as HTMLInputElement;
    this.reviewUserFieldValue = document.getElementById('reviewUser-validation') as HTMLInputElement;
    this.approverUserFieldValue = document.getElementById('approverUser-validation') as HTMLInputElement;
    this.reviewAndapproveToggleValue = document.getElementById('reviewAndapprove-validation') as HTMLInputElement;
    this.reasonFieldValue = document.getElementById('reason-validation') as HTMLInputElement;

    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == '' || this.password == undefined || this.password == null) {
        this.passwordFieldValue && (this.passwordFieldValue.style.color = 'red');
      } else {
        this.passwordFieldValue && (this.passwordFieldValue.style.color = '#005c8a');
      }
    }
    if (this.buttonLabel == "Defer Action") {
      if (this.searchingByDeferReviewUser == null) {
        this.reviewUserFieldValue.style.color = 'red';
      } else {
        this.reviewUserFieldValue.style.color = '#005c8a';
      }

      if (this.searchingByDeferApproveUser == null) {
        this.approverUserFieldValue.style.color = 'red';
      } else {
        this.approverUserFieldValue.style.color = '#005c8a';
      }
    } else if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {
      if (this.selectedStatus == null) {
        this.reviewAndapproveToggleValue.style.color = 'red';
      } else {
        this.reviewAndapproveToggleValue.style.color = '#005c8a';

        // }
      }
      if (!this.reason && this.selectedStatus?.includes('Rejected')) {
        this.reasonFieldValue.style.color = 'red';
      } else {
        this.reasonFieldValue.style.color = '#005c8a';
      }
    }

  }

  radioChange(event: any) {
    if (this.reviewAndapproveToggleValue != undefined) {
      this.reviewAndapproveToggleValue.style.color = '#005c8a';
    }
  }


  submitForReview() {
    this.searchingByDeferReviewUser = null;
    this.searchingByDeferApproveUser = null;
    this.action.listOfStages = "";
    this.action.listOfFlexifields = "";
    this.action.refNo = this.qmsservice.activityId;
    this.action.module = this.qmsservice.moduleName;
    if (this.searchingByRequestedAt != null) {
      this.action.actionAt = this.searchingByRequestedAt;
    }
    this.action.coreBusinessArea = "";
    this.action.refNo = this.qmsservice.activityId;

    if (this.action.targetDate) {
      this.action.targetDate = new Date(this.action.targetDate);
      this.action.targetDate = this.appService.dateZoneConvertion(this.action.targetDate);
    } else {
      this.action.targetDate = null;
    }
    if (this.action.actualActionCompletedOn) {
      this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
      this.action.actualActionCompletedOn = this.appService.dateZoneConvertion(this.action.actualActionCompletedOn);
    } else {
      this.action.actualActionCompletedOn = null;
    }

    if (this.coreBusinessAreaNameDropdown.length > 0) {
      if (this.coreBusinessAreaNameValue.length > 0) {
        for (let y = 0; y < this.coreBusinessAreaNameValue.length; y++) {
          this.action.coreBusinessArea += this.coreBusinessAreaNameValue[y];
          this.action.coreBusinessArea += y == this.coreBusinessAreaNameValue.length - 1 ? "" : ",";
        }
      }
    } else {
      this.action.coreBusinessArea = this.coreBusinessAreaNameValue.length == 0 ? "" : this.coreBusinessAreaNameValue;
    }

    this.action.actionType = this.selectedActionType?.length ? this.selectedActionType?.join(',') ?? null : null;

    if (this.searchByDepartmentCode != null) {
      this.action.assignedToDepartment = this.searchByDepartmentCode;
    }
    if (this.action.reviewedByUser == 0) {
      this.action.reviewedByUser = 0;
    } else if (this.searchingByReviewUser) {
      this.action.reviewedByUser = this.searchingByReviewUser;
    } else {
      this.action.reviewedByUser = null;
    }

    if (this.action.approvedByUser == 0) {
      this.action.approvedByUser = 0;
    } else if (this.searchingByApproveUser) {
      this.action.approvedByUser = this.searchingByApproveUser;
    } else {
      this.action.approvedByUser = null;
    }

    if (this.searchingByDeferReviewUser != null) {
      this.action.deferReviewedByUser = this.searchingByDeferReviewUser;
    }
    if (this.searchingByDeferApproveUser != null) {
      this.action.deferApprovedByUser = this.searchingByDeferApproveUser;
    }
    let data: any = this.action;
    data.actionPerformed = this.action.actionPerformed ? "Y" : "N";
    delete data.createdOn;
    delete data.updatedOn;
    delete data.reviewRequestedOn;
    delete data.reviewCompletedOn;
    delete data.approvalRequestedOn;
    delete data.approvalCompletedOn;
    this.appService.updateQmsAction(data).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S') {
          this.idCall(this.action.actionId);
          let selectedStatus
          if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {
            selectedStatus = this.selectedStatus
          } else {
            selectedStatus = this.buttonLabel
          }

          let data = {
            actionId: this.action.actionId,
            currentStatus: this.action.status,
            buttonOperation: selectedStatus,
            comments: this.reason,
          }

          this.appService.performActionsAction(data).subscribe({
            next: (Response: any) => {
              this.isProcessing = false;
              if (Response.resultType == "S") {
                this.buttongetCall();
                this.idCall(this.action.actionId);
                this.getCall();
                this.visibleConfirmWithReason.close();
                this.isProcessing = true;
              }
              this.showSnackBar(Response.result, Response.resultType);
              this.isProcessing = false;
            },
            error: (error) => {
              this.isProcessing = false;
              throw error;
            }
          });

        } else {
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  reviewAndApprove(data: any) {
    this.appService.performActionsAction(data).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.buttongetCall();
        this.idCall(this.action.actionId);
        this.getCall();
        this.visibleConfirmWithReason.close();
        this.isProcessing = true;
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        //duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      },
      error: (error) => {
        console.log(error);
      }
    });
    this.isProcessing = false;
  }

  htmlContent: any;
  deferActionPerfonce() {
    this.action.listOfStages = "";
    this.action.listOfFlexifields = "";
    if ((localStorage.getItem("adEnabled") != 'Y' && this.password == '') || this.searchingByDeferReviewUser == null || this.searchingByDeferApproveUser == null) {
      this.dynamicButtonFieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      this.action.refNo = this.qmsservice.activityId;
      this.action.module = this.qmsservice.moduleName;
      if (this.searchingByRequestedAt != null) {
        this.action.actionAt = this.searchingByRequestedAt;
      }
      this.action.coreBusinessArea = "";
      this.action.refNo = this.qmsservice.activityId;

      if (this.action.targetDate) {
        this.action.targetDate = new Date(this.action.targetDate);
        this.action.targetDate = this.appService.dateZoneConvertion(this.action.targetDate);
      } else {
        this.action.targetDate = null;
      }

      if (this.action.actualActionCompletedOn) {
        this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
        this.action.actualActionCompletedOn = this.appService.dateZoneConvertion(this.action.actualActionCompletedOn);
      } else {
        this.action.actualActionCompletedOn = null;
      }

      if (this.coreBusinessAreaNameDropdown.length > 0) {
        if (this.coreBusinessAreaNameValue.length > 0) {
          for (let y = 0; y < this.coreBusinessAreaNameValue.length; y++) {
            this.action.coreBusinessArea += this.coreBusinessAreaNameValue[y];
            this.action.coreBusinessArea += y == this.coreBusinessAreaNameValue.length - 1 ? "" : ",";
          }
        }
      } else {
        this.action.coreBusinessArea = this.coreBusinessAreaNameValue.length == 0 ? "" : this.coreBusinessAreaNameValue;
      }

      this.action.actionType = this.selectedActionType?.length ? this.selectedActionType?.join(',') ?? null : null;

      if (this.searchByDepartmentCode != null) {
        this.action.assignedToDepartment = this.searchByDepartmentCode;
      }
      if (this.action.reviewedByUser == 0) {
        this.action.reviewedByUser = 0;
      } else if (this.searchingByReviewUser) {
        this.action.reviewedByUser = this.searchingByReviewUser;

      } else {
        this.action.reviewedByUser = null;
      }

      if (this.action.approvedByUser == 0) {
        this.action.approvedByUser = 0;
      } else if (this.searchingByApproveUser) {
        this.action.approvedByUser = this.searchingByApproveUser;
      } else {
        this.action.approvedByUser = null;
      }

      if (this.searchingByDeferReviewUser != null) {
        this.action.deferReviewedByUser = this.searchingByDeferReviewUser;
      }
      if (this.searchingByDeferApproveUser != null) {
        this.action.deferApprovedByUser = this.searchingByDeferApproveUser;
      }
      if (this.searchingByAssignedUser != null) {
        this.action.assignedToUser = this.searchingByAssignedUser;
      }
      let data: any = this.action;
      data.actionPerformed = this.action.actionPerformed ? "Y" : "N";
      delete data.createdOn;
      delete data.updatedOn;
      delete data.reviewRequestedOn;
      delete data.reviewCompletedOn;
      delete data.approvalRequestedOn;
      delete data.approvalCompletedOn;
      this.appService.updateQmsAction(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.idCall(this.action.actionId);
            let selectedStatus
            if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {
              selectedStatus = this.selectedStatus
            } else {
              selectedStatus = this.buttonLabel
            }

            let data = {
              actionId: this.action.actionId,
              currentStatus: this.action.status,
              buttonOperation: selectedStatus,
              comments: this.reason,
            }

            this.appService.performActionsAction(data).subscribe({
              next: (Response: any) => {
                this.isProcessing = false;
                if (Response.resultType == "S") {
                  this.buttongetCall();
                  this.idCall(this.action.actionId);
                  this.getCall();
                  this.visibleConfirmWithReason.close();
                  this.isProcessing = true;
                }
                this.showSnackBar(Response.result, Response.resultType);
                this.isProcessing = false;
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });

          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if ((localStorage.getItem("adEnabled") != 'Y' && this.password == '') || ((this.buttonLabel == 'Review' || this.buttonLabel == 'Approve') && (!this.selectedStatus || (this.selectedStatus?.includes("Rejected") && !this.reason)))) {
      this.dynamicButtonFieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else if (this.buttonLabel == "Defer Action") {
      this.action.listOfStages = "";
      this.action.listOfFlexifields = "";
      if ((localStorage.getItem("adEnabled") != 'Y' && this.password == '') || this.searchingByDeferReviewUser == null || this.searchingByDeferApproveUser == null) {
        this.dynamicButtonFieldValidation();
        alert('Please enter the all mandatory fields...');
        this.isProcessing = false;
      } else if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("DeferAction");

      } else {
        let data = {
          userName: this.userName,
          password: this.password
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            this.deferActionPerfonce();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })


      }
    } else if (this.buttonLabel == "Submit for Review" && this.searchingByReviewUser == null) {
      this.isProcessing = false;
      this.showmessage("Please select reviewer before submit for review", "E");

    } else if (this.buttonLabel == "Submit for Review" && this.searchingByApproveUser == null) {
      this.isProcessing = false;
      this.showmessage("Please select approver before submit for review", "E");

    } else if (this.buttonLabel == "Submit for Review" || this.buttonLabel == "Submit for Approval") {

      if (localStorage.getItem("adEnabled") == 'Y') {
        this.authEnable("forsubmitforreview");
      } else {
        let data = {
          userName: this.userName,
          password: this.password
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            this.submitForReview();
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }

    } else if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {

      let selectedStatus: any;
      if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {
        selectedStatus = this.selectedStatus
      } else {
        selectedStatus = this.buttonLabel
      }
      if (localStorage.getItem("adEnabled") == 'Y') {

        this.authEnable("Review");
      } else {

        let data = {
          userName: this.userName,
          password: this.password
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            let data = {
              // moduleName:this.qmsservice.moduleName,
              actionId: this.action.actionId,
              currentStatus: this.action.status,
              buttonOperation: selectedStatus,
              comments: this.reason,
            }
            this.reviewAndApprove(data);
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              //duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else if (this.buttonLabel == 'Complete Action') {
      this.submitForReview();
    } else {

      let selectedStatus: any;
      if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {
        selectedStatus = this.selectedStatus
      } else {
        selectedStatus = this.buttonLabel
      }
      this.isProcessing = true;
      let data = {
        actionId: this.action.actionId,
        currentStatus: this.action.status,
        buttonOperation: selectedStatus,
        comments: this.reason,
      }
      this.appService.performActionsAction(data).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.buttongetCall();
          this.idCall(this.action.actionId);
          this.getCall();
          this.visibleConfirmWithReason.close();
          this.isProcessing = true;
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          //duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })

    }

  }
  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            if (flag == "forsubmitforreview") {
              this.submitForReview();
            } else if (flag == "Review") {
              let selectedStatus: any;
              if (this.buttonLabel == "Review" || this.buttonLabel == "Approve") {
                selectedStatus = this.selectedStatus
              } else {
                selectedStatus = this.buttonLabel
              }
              let data = {
                actionId: this.action.actionId,
                currentStatus: this.action.status,
                buttonOperation: selectedStatus,
                comments: this.reason,
              }
              this.reviewAndApprove(data);
            } else if (flag == 'DeferAction') {
              this.deferActionPerfonce();
            }
          }
        },
        error: (error) => {
          this.isProcessing = false;
        }
      });
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    if (this.filteredBusinessAreaValue?.length != 0) {
      for (let i = 0; i < this.filteredBusinessAreaValue?.length; i++) {
        this.coreBusinessAreaNameDropdown = this.coreBusinessAreaNameDropdown.concat({
          valueExp: this.filteredBusinessAreaValue[i],
          displayExp: this.filteredBusinessAreaValue[i]
        });
      }
    }
  }

  openDeletePopup(data: any) {
    this.appService.getQmsActionsByActionId(data.ACTION_ID).subscribe((data: any) => {
      data.actionPerformed = data.actionPerformed == "Y";
      this.action = data;

      if (this.action.targetDate) {
        this.action.targetDate = new Date(this.action.targetDate);
        this.action.targetDate = this.appService.dateZoneConvertion(this.action.targetDate);
      } else {
        this.action.targetDate = null;
      }
      if (this.action.actualActionCompletedOn) {
        this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
        this.action.actualActionCompletedOn = this.appService.dateZoneConvertion(this.action.actualActionCompletedOn);
      } else {
        this.action.actualActionCompletedOn = null;
      }

      this.popupDataTitle = "Delete Action";
      this.action.deleteReason = null;

      this.message.showDocumentActionButtons = (data.assignedToUser == this.message.getUserId() && (data.status == 'Open' || data.status == 'Review Rejected' || data.status == 'Approval Rejected' || data.status == 'Deferred(Review Rejected)' || data.status == 'Deferred(Approval Rejected)'));
      this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
      this.isProcessing = false;
    });

  };
  $commonConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    adaptivePosition: true,
  }
  $targetDateConfig = {
    ...this.$commonConfig,
    minDate: new Date(),
    maxDate: new Date(this.qmsservice.activity.expcetedClosureOn),
  }
  $dateConfig = {
    ...this.$commonConfig,
    maxDate: new Date(),
  }
  $dateTimeConfig = {
    ...this.$commonConfig,
    dateInputFormat: this.dateFormat + " HH:mm:ss ",
    maxDate: new Date(),
  }

  $getDynamicConfig() {
    return {
      ...this.$commonConfig,
      minDate: new Date(this.action.createdOn),
      maxDate: new Date()
    }
  }

  actionNameFieldValue: any;
  activityAtFieldValue: any;
  coreBusinessAreaNameValueFieldValue: any;
  descriptionFieldValue: any;
  assignedToFieldValue: any;
  targetDateToFieldValue: any;
  performedActionDetailsFieldValue: any;
  fieldValidation() {
    this.actionNameFieldValue = document.getElementById('actionName-validation') as HTMLInputElement;
    this.activityAtFieldValue = document.getElementById('activityAt-validation') as HTMLInputElement;
    this.coreBusinessAreaNameValueFieldValue = document.getElementById('coreBusinessAreaNameValue-validation') as HTMLInputElement;
    this.descriptionFieldValue = document.getElementById('description-validation') as HTMLInputElement;
    this.assignedToFieldValue = document.getElementById('assignedTo-validation') as HTMLInputElement;
    this.targetDateToFieldValue = document.getElementById('targetDate-validation') as HTMLInputElement;
    this.performedActionDetailsFieldValue = document.getElementById('performedActionDetails-validation') as HTMLInputElement;

    if (this.action.actionName == null || this.action.actionName == undefined || this.action.actionName == '') {
      this.actionNameFieldValue.style.color = 'red';
    } else {
      this.actionNameFieldValue.style.color = '#005c8a';
    }

    if (this.searchingByRequestedAt == null) {
      this.activityAtFieldValue.style.color = 'red';
    } else {
      this.activityAtFieldValue.style.color = '#005c8a';
    }

    if (this.coreBusinessAreaNameValue.length == 0) {
      this.coreBusinessAreaNameValueFieldValue.style.color = 'red';
    } else {
      this.coreBusinessAreaNameValueFieldValue.style.color = '#005c8a';
    }

    if (this.action.assignedTo) {
      this.assignedToFieldValue.style.color = '#005c8a';
    } else {
      this.assignedToFieldValue.style.color = 'red';
    }

    if (this.action.targetDate) {
      this.targetDateToFieldValue.style.color = '#005c8a';
    } else {
      this.targetDateToFieldValue.style.color = 'red';
    }

    if (this.visibleEditButton && this.action.actionPerformed) {

      const isEmpty = !this.action.performedActionDetails ||
        this.action.performedActionDetails.trim() === '';

      if (this.performedActionDetailsFieldValue) {
        this.performedActionDetailsFieldValue.style.color = isEmpty ? 'red' : '#005c8a';
      }
    }

  }

  changeExpcetedClosureOnDate(items: any) {
    this.targetDateToFieldValue = document.getElementById('targetDate-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.targetDateToFieldValue.style.color = '#005c8a';
    } else {
      this.targetDateToFieldValue.style.color = 'red';
    }
  }

  onFieldFocusout() {
    if (this.actionNameFieldValue != undefined) {
      if (this.action.actionName == "" || this.action.actionName == undefined) {
        this.actionNameFieldValue.style.color = 'red';
      } else {
        this.actionNameFieldValue.style.color = '#005c8a';
      }
    }

    if (this.performedActionDetailsFieldValue != undefined) {
      if (this.action.performedActionDetails == null || this.action.performedActionDetails == undefined || this.action.performedActionDetails == '') {
        this.performedActionDetailsFieldValue.style.color = 'red';
      } else {
        this.performedActionDetailsFieldValue.style.color = '#005c8a';
      }
    }

    if (this.deleteReasonFieldValue != undefined) {
      if (this.action.deleteReason == "" || this.action.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '#005c8a';
      }
    }
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qmsservice.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qmsservice.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  async addAndEditFunction() {

    if (this.qmsservice.activity.status == "In Progress" && this.visibleEditButton && !this.searchUsersComponent.isSwitchingUser && await this.qmsservice.validateExtension({ refNo: this.qmsservice.activityId, extensionFor: "Action", subTaskNo: this.action.actionId })) {
      setTimeout(() => {
        this.showSnackBar(this.qmsservice.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.isProcessing = true;
    if (!this.searchUsersComponent.isSwitchingUser && (!this.action.actionName || (this.qmsservice.moduleName !== 'CC' && (!this.searchingByRequestedAt || !this.coreBusinessAreaNameValue.length)) ||
      !this.action.assignedTo || !this.action.targetDate || (this.qmsservice.moduleName == 'CAPA' && this.dynamicLabel['ACTION_TYPE'].isRemovable != 'Y' && !this.selectedActionType.length))) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else if (this.visibleEditButton == false) {
      this.action.listOfStages = "";
      this.action.listOfFlexifields = "";

      this.action.refNo = this.qmsservice.activityId;
      this.action.module = this.qmsservice.moduleName;

      if (this.action.targetDate) {
        this.action.targetDate = new Date(this.action.targetDate);
        this.action.targetDate = this.appService.dateZoneConvertion(this.action.targetDate);
      } else {
        this.action.targetDate = null;
      }

      if (this.searchingByRequestedAt) {
        this.action.actionAt = this.searchingByRequestedAt;
      } else {
        this.action.actionAt = null;
      }

      this.action.coreBusinessArea = "";
      this.action.refNo = this.qmsservice.activityId;

      if (this.coreBusinessAreaNameDropdown.length > 0) {
        if (this.coreBusinessAreaNameValue.length > 0) {
          for (let y = 0; y < this.coreBusinessAreaNameValue.length; y++) {
            this.action.coreBusinessArea += this.coreBusinessAreaNameValue[y];
            this.action.coreBusinessArea += y == this.coreBusinessAreaNameValue.length - 1 ? "" : ",";
          }
        } else {
          this.action.coreBusinessArea = null;
        }
      } else {
        this.action.coreBusinessArea = this.coreBusinessAreaNameValue.length == 0 ? "" : this.coreBusinessAreaNameValue;
      }

      this.action.actionType = this.selectedActionType?.length ? this.selectedActionType?.join(',') ?? null : null;

      if (this.searchByDepartmentCode) {
        this.action.assignedToDepartment = this.searchByDepartmentCode;
      } else {
        this.action.assignedToDepartment = null;
      }

      if (this.searchingByReviewUser) {
        this.action.reviewedByUser = this.searchingByReviewUser;
      } else {
        this.action.reviewedByUser = null;
      }

      if (this.searchingByApproveUser) {
        this.action.approvedByUser = this.searchingByApproveUser;
      } else {
        this.action.approvedByUser = null;
      }


      if (this.searchingByDeferReviewUser != null) {
        this.action.deferReviewedByUser = this.searchingByDeferReviewUser;
        //
      }
      if (this.searchingByDeferApproveUser != null) {
        this.action.deferApprovedByUser = this.searchingByDeferApproveUser;
      }

      if (this.action.actualActionCompletedOn) {
        this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
        this.action.actualActionCompletedOn = this.appService.dateZoneConvertion(this.action.actualActionCompletedOn);
      } else {
        this.action.actualActionCompletedOn = null;
      }
      let data = this.action;
      data.actionPerformed = "N";
      data.actionDescription = this.action.actionDescription;
      this.appService.createQmsAction(data).subscribe({
        next: (Response: any) => {
          this.showSnackBar(Response.result, Response.resultType);
          if (Response.resultType == 'S') {
            if (this.visibleAddAndEditPopup) {
              this.visibleAddAndEditPopup.close();
            }
            this.buttongetCall();
            this.getCall();
            if (this.qmsservice.isSwitchUSerPopupOpened) {
              this.switchuserComponent.cancelSwitchUserPopup();
              this.switchuserComponent.closeConfirmationPopup();
            }
            this.isProcessing = false;
          }
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else if (!this.searchUsersComponent.isSwitchingUser && this.action.actionPerformed) {
      if (this.action.performedActionDetails == null || this.action.performedActionDetails == undefined || this.action.performedActionDetails == '') {
        this.fieldValidation();
        alert('Please enter the all mandatory fields...');
        this.isProcessing = false;
      } else {
        this.action.listOfStages = "";
        this.action.listOfFlexifields = "";
        this.action.refNo = this.qmsservice.activityId;
        this.action.module = this.qmsservice.moduleName;
        this.action.coreBusinessArea = "";
        this.action.refNo = this.qmsservice.activityId;

        if (this.action.targetDate) {
          this.action.targetDate = new Date(this.action.targetDate);
          this.action.targetDate = this.appService.dateZoneConvertion(this.action.targetDate);
        } else {
          this.action.targetDate = null;
        }

        if (this.action.actualActionCompletedOn) {
          this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
          this.action.actualActionCompletedOn = this.appService.dateZoneConvertion(this.action.actualActionCompletedOn);
        } else {
          this.action.actualActionCompletedOn = null;
        }

        if (this.searchingByRequestedAt) {
          this.action.actionAt = this.searchingByRequestedAt;
        } else {
          this.action.actionAt = null;
        }
        if (this.coreBusinessAreaNameDropdown.length > 0) {
          if (this.coreBusinessAreaNameValue.length > 0) {
            for (let y = 0; y < this.coreBusinessAreaNameValue.length; y++) {
              this.action.coreBusinessArea += this.coreBusinessAreaNameValue[y];
              this.action.coreBusinessArea += y == this.coreBusinessAreaNameValue.length - 1 ? "" : ",";
            }
          } else {
            this.action.coreBusinessArea = null;
          }
        } else {
          this.action.coreBusinessArea = this.coreBusinessAreaNameValue.length == 0 ? "" : this.coreBusinessAreaNameValue;
        }

        this.action.actionType = this.selectedActionType?.length ? this.selectedActionType?.join(',') ?? null : null;

        if (this.searchByDepartmentCode) {
          this.action.assignedToDepartment = this.searchByDepartmentCode;
        } else {
          this.action.assignedToDepartment = null;
        }

        if (this.action.reviewedByUser == 0) {
          this.action.reviewedByUser = 0;
        } else if (this.searchingByReviewUser) {
          this.action.reviewedByUser = this.searchingByReviewUser;
        } else {
          this.action.reviewedByUser = null;
        }

        if (this.action.approvedByUser == 0) {
          this.action.approvedByUser = 0;
        } else if (this.searchingByApproveUser) {
          this.action.approvedByUser = this.searchingByApproveUser;
        } else {
          this.action.approvedByUser = null;
        }

        if (this.searchingByDeferReviewUser != null) {
          this.action.deferReviewedByUser = this.searchingByDeferReviewUser;
        }
        if (this.searchingByDeferApproveUser != null) {
          this.action.deferApprovedByUser = this.searchingByDeferApproveUser;
        }

        let data: any = this.action;
        data.actionPerformed = data ? "Y" : "N";
        data.actionDescription = this.action.actionDescription;
        delete data.createdOn;
        delete data.updatedOn;
        delete data.reviewRequestedOn;
        delete data.reviewCompletedOn;
        delete data.approvalRequestedOn;
        delete data.approvalCompletedOn;
        this.appService.updateQmsAction(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.buttongetCall();
              this.idCall(this.action.actionId);
              this.getCall();
              if (this.qmsservice.isSwitchUSerPopupOpened) {
                this.switchuserComponent.cancelSwitchUserPopup();
                this.switchuserComponent.closeConfirmationPopup();
              }
              this.isProcessing = false;
            }
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    } else {
      this.action.listOfStages = "";
      this.action.listOfFlexifields = "";

      this.action.refNo = this.qmsservice.activityId;
      this.action.module = this.qmsservice.moduleName;
      this.action.coreBusinessArea = "";
      this.action.refNo = this.qmsservice.activityId;

      if (this.action.targetDate) {
        this.action.targetDate = new Date(this.action.targetDate);
        this.action.targetDate = this.appService.dateZoneConvertion(this.action.targetDate);
      } else {
        this.action.targetDate = null;
      }
      if (this.action.actualActionCompletedOn) {
        this.action.actualActionCompletedOn = new Date(this.action.actualActionCompletedOn);
        this.action.actualActionCompletedOn = this.appService.dateZoneConvertion(this.action.actualActionCompletedOn);
      } else {
        this.action.actualActionCompletedOn = null;
      }
      if (this.searchingByRequestedAt) {
        this.action.actionAt = this.searchingByRequestedAt;
      } else {
        this.action.actionAt = null;
      }
      if (this.coreBusinessAreaNameDropdown.length > 0) {
        if (this.coreBusinessAreaNameValue.length > 0) {
          for (let y = 0; y < this.coreBusinessAreaNameValue.length; y++) {
            this.action.coreBusinessArea += this.coreBusinessAreaNameValue[y];
            this.action.coreBusinessArea += y == this.coreBusinessAreaNameValue.length - 1 ? "" : ",";
          }
        } else {
          this.action.coreBusinessArea = null;
        }
      } else {
        this.action.coreBusinessArea = this.coreBusinessAreaNameValue.length == 0 ? "" : this.coreBusinessAreaNameValue;
      }

      this.action.actionType = this.selectedActionType?.length ? this.selectedActionType?.join(',') ?? null : null;
      if (this.searchByDepartmentCode) {
        this.action.assignedToDepartment = this.searchByDepartmentCode;
      } else {
        this.action.assignedToDepartment = null;
      }

      if (this.action.reviewedByUser == 0) {
        this.action.reviewedByUser = 0;
      } else if (this.searchingByReviewUser) {
        this.action.reviewedByUser = this.searchingByReviewUser;
      } else {
        this.action.reviewedByUser = null;
      }

      if (this.action.approvedByUser == 0) {
        this.action.approvedByUser = 0;
      } else if (this.searchingByApproveUser) {
        this.action.approvedByUser = this.searchingByApproveUser;
      } else {
        this.action.approvedByUser = null;
      }

      if (this.searchingByDeferReviewUser != null) {
        this.action.deferReviewedByUser = this.searchingByDeferReviewUser;
      }
      if (this.searchingByDeferApproveUser != null) {
        this.action.deferApprovedByUser = this.searchingByDeferApproveUser;
      }

      let data: any = this.action;
      data.actionPerformed = this.action.actionPerformed ? "Y" : "N";
      data.actionDescription = this.action.actionDescription;
      delete data.createdOn;
      delete data.updatedOn;
      delete data.reviewRequestedOn;
      delete data.reviewCompletedOn;
      delete data.approvalRequestedOn;
      delete data.approvalCompletedOn;
      this.appService.updateQmsAction(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.buttongetCall();
            this.idCall(this.action.actionId);
            this.getCall();
            this.searchUsersComponent.isSwitchingUser && (this.searchUsersComponent.isSwitchingUser = false)

            if (this.qmsservice.isSwitchUSerPopupOpened) {
              this.switchuserComponent.cancelSwitchUserPopup();
              this.switchuserComponent.closeConfirmationPopup();
            }
            this.isProcessing = false;
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '#005c8a';
    }
  }

  deleteFiledValue: any;
  deleteFunction(qmsBusinesssAreaFieldData: any) {
    this.action.refNo = this.qmsservice.activityId;
    this.action.module = this.qmsservice.moduleName;
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {

      this.action.actionPerformed = this.action.actionPerformed ? "Y" : "N";
      delete this.action.createdOn;
      delete this.action.updatedOn;
      delete this.action.reviewRequestedOn;
      delete this.action.reviewCompletedOn;
      delete this.action.approvalRequestedOn;
      delete this.action.approvalCompletedOn;
      this.appService.deleteQmsAction(this.action).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.visibleDeletePopup.close();
            this.getCall();
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  openswitchuser(value: any) {
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = "Action";
    this.message.switchuserRole = value;
    this.message.switchComparisonUser = null;
    if (value == "Action Reviewer") {
      this.message.switchUserCurrentValue = this.searchingByReviewUser;
      this.message.switchedUser = this.searchingByReviewUser;
      this.message.switchUserdropDownList = this.listOfReviewerUsersDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (value == "Action Approver") {
      this.message.switchUserCurrentValue = this.searchingByApproveUser;
      this.message.switchedUser = this.searchingByApproveUser;
      this.message.switchUserdropDownList = this.listOfApproverUsersDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (value == "Action Defer Reviewer") {
      this.message.switchUserCurrentValue = this.searchingByDeferReviewUser;
      this.message.switchedUser = this.searchingByDeferReviewUser;
      this.message.switchComparisonUser = this.action.assignedToUser;
      this.message.switchUserdropDownList = this.listOfDeferredReviewerUsersDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    } else if (value == "Action Defer Approver") {
      this.message.switchUserCurrentValue = this.searchingByDeferApproveUser;
      this.message.switchedUser = this.searchingByDeferApproveUser;
      this.message.switchComparisonUser = this.action.assignedToUser;
      this.message.switchUserdropDownList = this.listOfDeferredApproverUsersDropdown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) || []
    }
    this.switchuserComponent.openswitchuser(value, 'Action');
  };

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Action Reviewer") {
      this.searchingByReviewUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "Action Approver") {
      this.searchingByApproveUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "Action Defer Reviewer") {
      this.searchingByDeferReviewUser = this.message.switchedUser;
    }
    else if (this.message.switchuserRole == "Action Defer Approver") {
      this.searchingByDeferApproveUser = this.message.switchedUser;
    }
    this.switchuserComponent.saveMethod();
    this.addAndEditFunction();
  }

  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'AU': this.qmsservice.activity.auId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId };

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, action: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : action.ACTION_ID;
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'ACTIONS';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Action Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(action);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.gridObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Action Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.gridObj.gridName, this.gridObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmit() {
    this.getCall();
    this.getDynamicLabel();
  };

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  urlForAction: any = '';
  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string, coloumn: string): void {

    if (coloumn == 'activity') {
      this.urlForAction = this.qmsservice.activity
    } else {
      this.urlForAction = this.action
    };

    const editorTitleMapping: Record<string, any> = {
      'Current State': this.qmsservice.activityDynamicLabel?.['CURRENT_STATE']?.fieldName,
      'CAPA Description': this.qmsservice.activityDynamicLabel?.['CAPA_DESCRIPTION']?.fieldName,
      'Deviation Description': this.qmsservice.activityDynamicLabel?.['DV_DESCRIPTION']?.fieldName,
      'Description': this.qmsservice.activityDynamicLabel?.['DESCRIPTION']?.fieldName,
      'Complaint Description': this.qmsservice.activityDynamicLabel?.['COMPLAINT_DESCRIPTION']?.fieldName,
      'Proposed Change': this.qmsservice.activityDynamicLabel?.['PROPOSED_CHANGE']?.fieldName,
      'Investigation Summary': this.qmsservice.activityDynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName,
      'Impact Description': this.qmsservice.activityDynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName,
      'Initial Assessment': this.qmsservice.activityDynamicLabel?.['INITIAL_ASSESSMENT']?.fieldName,
      'Action Description': this.dynamicLabel?.['ACTION_DESCRIPTION']?.fieldName,
      'Performed Action Details': this.dynamicLabel?.['PERFORMED_ACTION_DETAILS']?.fieldName
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.urlForAction[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.urlForAction[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }
  private getModel(value: string): any {
    value = (value == 'Deviation Description') ? 'dv description' : value;
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };



  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }


  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe({
      next: () => {
        this.snackbarRef.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
    })
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  async searchAssignTo(workingFor: string) {
    if (this.qmsservice.activity.status == "In Progress" && workingFor != "switch" && await this.qmsservice.validateExtension({ refNo: this.qmsservice.activityId, extensionFor: "Action", subTaskNo: this.action.actionId })) {
      setTimeout(() => {
        this.showSnackBar(this.qmsservice.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }

    this.searchUsersComponent.popupTitle = 'Assign To';
    this.searchUsersComponent.isSwitchingUser = workingFor == 'switch';
    this.searchUsersComponent.isSwitchingUser && (this.message.switchUserCurrentValue = this.action.assignedToUser);
    this.searchUsersComponent.selectionMode = 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    this.action.assignedToUser = this.qmsservice.selectedSearchUserId;
    this.action.assignedTo = this.qmsservice.selectedSearchUserName;
    if (this.searchUsersComponent.isSwitchingUser) {
      this.addAndEditFunction();
    }
  }

  @ViewChild('dynamicGridPopup', { static: true }) dynamicGridPopup: TemplateRef<any>;
  visibledynamicGridPopup: MatDialogRef<TemplateRef<any>>;
  dynamicGridPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '1px', left: '7%' },
    maxWidth: '91vw',
  };
  dynamicgriddata: any;
  openDynamicGrid(list: any) {
    this.dynamicgriddata = {
      actionId: list.ACTION_ID,
      gridName: 'EXTENSION',
      pageName: 'Action-Extension'
    };
    this.visibledynamicGridPopup = this.dialog.open(this.dynamicGridPopup, this.dynamicGridPopupConfig);
  };

  dynamicGridCancel() {
    this.visibledynamicGridPopup.close();
  }

  grid: any = [];
  gridTemp: any = [];
  selectedGridData: any = [];
  gridObj: any = {};

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  parentCheckBox: boolean = false;
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    this.selectedGridData = [];
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "ACTIONS",
      groupId: 0
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          refNo: this.qmsservice.activityId,
        }
        this.gridObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.grid.sort(function (a: any, b: any) { return a.SL_NO - b.SL_NO; });
            this.valueChange.emit({ action: this.actionsDataForGrid });
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.getDynamicLabel()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any; cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 150;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';

          // Apply hyperlink styling for first two columns
          if (index2 <= 2) {
            column.style.color = 'blue';
            column.style.textDecoration = 'underline';
            column.style.cursor = 'pointer';
          }

          if (index2 > 1) {
            colWidth += 150;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  onParentChanged(e: any) {
    if (e.target.checked) {
      this.selectedGridData = this.pagedItems.length == 10 ? this.grid : this.pagedItems;

      for (const element of this.grid) { element.childCheckBox = true }
    } else {

      this.selectedGridData = [];
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.selectedGridData?.some((copied: any) => copied.TEMPLATE_ID === checked.TEMPLATE_ID)) {
      this.selectedGridData.push(checked);
    }

    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  onChildUnchecked(unchecked: any) {
    this.selectedGridData = this.selectedGridData?.filter((copied: any) => copied.TEMPLATE_ID !== unchecked.TEMPLATE_ID);
  }

  refreshGrid() {
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
  }

  focus() { console.log(); }
  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;
  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;

  reorderPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  isReordered: boolean = false;

  openReorderPopup(): void {
    // Initialize NEW_ORDER based on current order
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
    this.isReordered = false;
    this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  cancelReorder(): void {
    this.visibleReorderPopup.close();
  }

  dragAndDrop(event: CdkDragDrop<string[]>): void {
    this.isReordered = true;
    moveItemInArray(this.grid, event.previousIndex, event.currentIndex);

    // Reassign NEW_ORDER after drag
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
  }

  async reorderActions(): Promise<void> {
    if (!this.isReordered) {
      this.visibleReorderPopup.close();
      return;
    }

    this.isProcessing = true;

    try {

      const tasks = this.grid.map(async (row: any) => {
        const actionDescription = await this.getClobValueCommon(
          row.PRIM_IDENTIFIER,
          row.tablevwname || this.gridObj.tableOrViewName,
          'ACTION_DESCRIPTION'
        );

        const performedActionDetails = await this.getClobValueCommon(
          row.PRIM_IDENTIFIER,
          row.tablevwname || this.gridObj.tableOrViewName,
          'PERFORMED_ACTION_DETAILS'
        );

        const justification = await this.getClobValueCommon(
          row.PRIM_IDENTIFIER,
          row.tablevwname || this.gridObj.tableOrViewName,
          'JUSTIFICATION'
        );

        const obj: any = {
          actionId: row.ACTION_ID,
          slNo: row.NEW_ORDER,
          refNo: row.REF_NO,
          module: row.MODULE,

          actionAt: row.ACTION_AT ?? null,
          actionName: row.ACTION_NAME,
          actionDescription,

          coreBusinessArea: row.CORE_BUSINESS_AREA,
          assignedToUser: row.ASSIGNED_TO_USER,
          assignedToDepartment: this.normalize(row.ASSIGNED_TO_DEPARTMENT),

          targetDate: row.TARGET_DATE
            ? this.appService.dateZoneConvertion(new Date(row.TARGET_DATE))
            : null,

          comments: this.normalize(row.COMMENTS),

          actionPerformed: row.ACTION_PERFORMED ? 'Y' : 'N',

          performedActionDetails,
          justification,

          actualActionCompletedOn: row.ACTUAL_ACTION_COMPLETED_ON
            ? this.appService.dateZoneConvertion(new Date(row.ACTUAL_ACTION_COMPLETED_ON))
            : null,

          reviewedByUser: this.normalize(row.REVIEWED_BY_USER),
          approvedByUser: this.normalize(row.APPROVED_BY_USER),
          deferReviewedByUser: this.normalize(row.DEFER_REVIEWED_BY_USER),
          deferApprovedByUser: this.normalize(row.DEFER_APPROVED_BY_USER),

          actionType: this.normalize(row.ACTION_TYPE),
        };

        await this.executeReorderUpdate(obj);
      });

      await Promise.all(tasks);

      this.isReordered = false;
      this.getCall();              // refresh grid
      this.visibleReorderPopup.close();
      this.showSnackBar('Actions reordered successfully', 'S');

    } catch (err) {
      console.error(err);
      this.showSnackBar('An error occurred while reordering actions.', 'E');
    } finally {
      this.isProcessing = false;
    }
  }

  private async executeReorderUpdate(obj: any): Promise<void> {
    const res: any = await firstValueFrom(this.appService.updateQmsAction(obj));
    if (res.resultType !== 'S') {
      throw new Error(res.result || 'Failed to update action order');
    }
  }

  private async getClobValueCommon(
    primeIdentifier: string,
    tableView: string,
    columnName: string
  ): Promise<string> {

    const docObj = {

      primeIdentifier,
      tableView,
      columnName
    };

    const response: any = await firstValueFrom(
      this.appService.getClobToViewAudit(docObj)
    );

    return response?.result ?? '';
  }

  private normalize(v: any): any {
    if (v === '') return null;
    if (v === 0 || v) return v;
    return null;
  }


}
